export default {"src":"/_next/static/media/AMZN.23a4a753.svg","height":18,"width":18};